import { unref as _unref, withModifiers as _withModifiers, createVNode as _createVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "flex items-start lg:items-center justify-start mt-6 w-full" }
const _hoisted_2 = { class: "flex items-center justify-start max-w-[70%] overflow-hidden" }
const _hoisted_3 = { class: "font-medium leading-[26px] text-greyScale900" }
const _hoisted_4 = { class: "error-message" }

import { useFieldArray, useField, ErrorMessage } from 'vee-validate';
import Dropzone from '../../ui/Dropzone.vue';
import { useOnDrop } from '../../../hooks/useOnDrop';
import DeleteItemButton from '../MedicationChoose/components/DeleteItemButton.vue';


export default {
  __name: 'UploadedFileField',
  setup(__props) {

const { fields, push, remove } = useFieldArray('uploadedFile');

useField('uploadedFile');

const { onDrop, onSelectFile } = useOnDrop(push, fields);

return (_ctx, _cache) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", null, [
      _createElementVNode("div", _hoisted_1, [
        _createVNode(Dropzone, {
          onChange: _unref(onSelectFile),
          onDrop: _withModifiers(_unref(onDrop), ["prevent"])
        }, null, 8, ["onChange", "onDrop"])
      ]),
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(fields), (field, id) => {
        return (_openBlock(), _createElementBlock("div", {
          key: field.key,
          class: "flex items-center min-h-[72px] justify-between mt-4 px-8 bg-greyScale50 rounded-lg"
        }, [
          _createElementVNode("div", _hoisted_2, [
            _createElementVNode("p", _hoisted_3, _toDisplayString(field.value.name), 1)
          ]),
          _createVNode(DeleteItemButton, {
            onDeleteItem: _unref(remove),
            id: id
          }, null, 8, ["onDeleteItem", "id"])
        ]))
      }), 128))
    ]),
    _createVNode(_unref(ErrorMessage), { name: "uploadedFile" }, {
      default: _withCtx(({ message }) => [
        _createElementVNode("p", _hoisted_4, _toDisplayString(message), 1)
      ]),
      _: 1
    })
  ], 64))
}
}

}